import $ from 'jquery';

$('.js-yandex-metric').each(function () {
    window.ym && window.ym(56412904, 'reachGoal', $(this).val());
});
